import { Input } from "../components/ui/input";
import { COUNTRY_CODES } from "./utils";

export const PhoneInput = ({ cc, phone, onCc, onPhone, testid, id }) => (
  <div className="flex gap-2">
    <select value={cc} onChange={onCc} data-testid={`${testid}-country`} aria-label="Country code"
      className="border rounded-md px-2 text-sm bg-white h-9">
      {COUNTRY_CODES.map(([code, c]) => <option key={code} value={code}>{c} {code}</option>)}
    </select>
    <Input id={id} type="tel" required minLength={5} pattern="[0-9 ]{5,20}" value={phone}
      onChange={onPhone} data-testid={`${testid}-phone`} placeholder="69..." />
  </div>
);
